<template>
  <v-navigation-drawer
    id="app-drawer"
    v-model="inputValue"
    app
    dark
    floating
    persistent
    mobile-break-point="991"
    width="260"
  >
    <v-img
      :src="image"
      height="100%"
    >
      <v-layout
        class="fill-height"
        tag="v-list"
        column
      >
        <v-list-tile avatar>
          <v-list-tile-avatar
            color="white"
          >
            <!--<v-img-->
              <!--:src="logo"-->
              <!--height="34"-->
              <!--contain-->
            <!--/>-->
          </v-list-tile-avatar>
          <v-list-tile-title class="title">
            Aqua J Mutual
          </v-list-tile-title>
        </v-list-tile>
        <v-divider />
        <v-list-tile
          v-if="responsive"
        >
          <v-text-field
            class="purple-input search-input"
            label="Search..."
            color="purple"
          />
        </v-list-tile>
        <v-list-tile
          v-for="(link, i) in links"
          :key="i"
          :to="link.to"
          :href="link.href"
          :active-class="color"
          avatar
          class="v-list-item"
          :ref="'drawer-item-'+link.to"
        >
          <v-list-tile-action>
            <v-icon>{{ link.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-title
            v-text="link.text"
          />
        </v-list-tile>
      </v-layout>
    </v-img>
  </v-navigation-drawer>
</template>

<script>
// Utilities
import {
  mapMutations,
  mapState
} from 'vuex'

export default {
  data: () => ({
    links: [
      {
        to: '/dashboard',
        icon: 'mdi-view-dashboard',
        text: 'Dashboard'
      },
      {
        to: '/services',
        icon: 'mdi-shield',
        text: 'Services'
      },
      {
        to: '/board',
        icon: 'mdi-clipboard',
        text: 'Board'
      },
      {
        to: '/pay',
        also: [ '/pay-sandbox' ],
        icon: 'mdi-cash',
        text: 'Pay'
      },
      {
        to: '/faq',
        icon: 'mdi-comment-question-outline',
        text: 'FAQ'
      },
      {
        href: './img/by_laws.pdf',
        icon: 'mdi-pdf-box',
        text: 'ByLaws'
      },
      {
        to: '/notices',
        icon: 'mdi-file-chart',
        text: 'Important Notices'
      }
    ],
    responsive: false
  }),
  computed: {
    ...mapState('app', ['image', 'color']),
    inputValue: {
      get () {
        return this.$store.state.app.drawer
      },
      set (val) {
        this.setDrawer(val)
      }
    },
    items () {
      return this.$t('Layout.View.items')
    }
  },
  watch: {
    '$route' (to, from) {
      // alternative highlight element
      if (to.path === '/pay-sandbox') {
        let vListTile = this.$refs['drawer-item-/pay'][0]
        vListTile.value = true
      } else if (from.path === '/pay-sandbox') {
        let vListTile = this.$refs['drawer-item-/pay'][0]
        vListTile.value = false
      }
    }
  },
  mounted () {
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResponsiveInverted)
  },
  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
    onResponsiveInverted () {
      if (window.innerWidth < 991) {
        this.responsive = true
      } else {
        this.responsive = false
      }
    }
  }
}
</script>

<style lang="scss">
  #app-drawer {
    .v-list__tile {
      border-radius: 4px;

      &--buy {
        margin-top: auto;
        margin-bottom: 17px;
      }
    }

    .v-image__image--contain {
      top: 9px;
      height: 60%;
    }

    .search-input {
      margin-bottom: 30px !important;
      padding-left: 15px;
      padding-right: 15px;
    }
  }
</style>
